import PropTypes from 'prop-types';
import React from 'react';
import { instructorResourceDefinition } from '../resources/instructorResourceDefinition';
import connect from './connect';
import { copyMaterials } from '../actions/terms';
import { createLoader } from '../loader';
import { setContent } from 'actions/manage_content';

import CopyMaterialsDisplay from './copy_materials_dialog/display.jsx';

class CopyMaterialsDialog extends React.Component {
    static displayName = 'CopyMaterialsDialog';

    static propTypes = {
        terms: PropTypes.array,
        sections: PropTypes.array,
        copyMaterials: PropTypes.func.isRequired,
        onClose: PropTypes.func,
        fromTerm: PropTypes.number,
        fromSection: PropTypes.number,
        selectedSections: PropTypes.array,
        includeLinks: PropTypes.bool,
        includeTags: PropTypes.bool,
        setContent: PropTypes.func,
    };

    state = { done: false };

    onSave = () => {
        this.setState({ done: true });
        this.props
            .copyMaterials({
                fromSectionId: this.props.fromSection,
                toSectionIds: this.props.selectedSections,
                includeLinks: this.props.includeLinks,
                includeTags: this.props.includeTags,
            })
            .finally(this.props.onClose);
    };

    render() {
        const {
            terms,
            sections,
            fromTerm,
            fromSection,
            selectedSections,
            includeLinks,
            includeTags,
            onClose,
            setContent,
        } = this.props;
        return (
            <CopyMaterialsDisplay
                done={this.state.done}
                onClose={onClose}
                onSave={this.onSave}
                terms={terms}
                sections={sections}
                fromTerm={fromTerm}
                fromSection={fromSection}
                selectedSections={selectedSections}
                includeLinks={includeLinks}
                includeTags={includeTags}
                setContent={setContent}
            />
        );
    }
}

export default connect(
    state => ({ rootState: state, ...state.manage_content }),
    { copyMaterials, setContent },
    null,
    { pure: true }
)(
    createLoader({
        component: CopyMaterialsDialog,
        resources: instructorResourceDefinition(),
    })
);



// WEBPACK FOOTER //
// ./src/components/copy_materials_dialog.jsx